/**
 * CargaCorreios
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {CargaCorreiosCollection} from '@/model/collection/CargaCorreiosCollection'

/* TODO: review generated class */
export class CargaCorreios extends Resource {
  idCargaCorreiosPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  cdCorreios: string | null = null

  get $id() {
    return this.idCargaCorreiosPk
  }
  set $id(val) {
    this.idCargaCorreiosPk = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaCorreios
   */
  async getCargaCorreios(id: number) {
    return await Request.get(`/admin/carga-correios/${id}`)
      .name('getCargaCorreios')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaCorreios
   */
  static async listCargaCorreios(params: any) {
    return await Request.get(`/admin/carga-correios`, {params})
      .name('listCargaCorreios')
      .as(CargaCorreiosCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaCorreios. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaCorreios() {
    return await Request.post(`/admin/carga-correios`, this)
      .name('persistCargaCorreios')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaCorreios to use it in a CSV file
   */
  static async listCsvCargaCorreios(params: any) {
    return await Request.get(`/admin/carga-correios/csv`, {params})
      .name('listCsvCargaCorreios')
      .as(CargaCorreiosCollection)
      .getData()
  }
}
